import { getApiBaseUrl } from './api';
import { getPublicApiBase } from './publicApi';

/**
 * Resolve a server-relative upload path (e.g. /uploads/branding/portal-logo.png) to a full URL for <img src>.
 * Uses the API origin (strip /api) so dev/prod match how static files are served with the API host.
 */
export function resolvePublicUploadUrl(relativePath, cacheBust) {
  if (relativePath == null || relativePath === '') return null;
  const p = String(relativePath).trim();
  if (!p) return null;
  if (/^https?:\/\//i.test(p)) {
    return appendCacheBust(p, cacheBust);
  }

  let base = '';
  if (typeof window !== 'undefined') {
    try {
      const api = getApiBaseUrl();
      base = api.replace(/\/api\/?$/i, '') || window.location.origin;
    } catch {
      base = window.location.origin;
    }
  }

  const pathPart = p.startsWith('/') ? p : `/${p}`;
  const url = `${base}${pathPart}`;
  return appendCacheBust(url, cacheBust);
}

function appendCacheBust(url, cacheBust) {
  if (cacheBust == null || cacheBust === '') return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}v=${encodeURIComponent(String(cacheBust))}`;
}

/**
 * Absolute URL for the current org logo image, served via GET /api/public/branding/file
 * (avoids loading /uploads/... directly — same path as the API proxy in dev).
 */
export function resolveBrandingLogoImageUrl(cacheBust) {
  const base = getPublicApiBase().replace(/\/+$/, '');
  const url = `${base}/branding/file`;
  return appendCacheBust(url, cacheBust);
}
